import Vue from 'vue'
import App from './App.vue'
import router from './route/router'
import './route/common'
import store from './store/store'
import './plugins/elementUI'
import './icon/iconfont.css'
import './plugins/VideoPlayer'
Vue.config.productionTip = false

import VueBus from 'vue-bus';

Vue.use(VueBus);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
